import { AlertCircleIcon, WarningIcon } from '@/components/icons';
import type { RateLevel } from '@/config/httpStats';
import { formatPercent } from '@/utils/format';
import './stats.css';

export interface RateBadgeProps {
  /** Share of requests, 0..1 */
  rate: number;
  level: RateLevel;
  /** What the rate measures, e.g. "5xx rate" (tooltip) */
  label: string;
}

const LEVEL_TEXT: Record<RateLevel, string> = {
  ok: '',
  warning: 'warning',
  critical: 'critical',
};

/**
 * Error-rate percentage, highlighted with an icon, color and screen-reader
 * text when it crosses a threshold (never color alone)
 */
export function RateBadge({ rate, level, label }: RateBadgeProps) {
  const percent = formatPercent(rate);
  const title = level === 'ok' ? `${label}: ${percent}` : `${label}: ${percent} (${LEVEL_TEXT[level]})`;

  return (
    <span className={`rate-badge rate-badge-${level}`} title={title} data-level={level}>
      {level === 'critical' && <AlertCircleIcon size={14} />}
      {level === 'warning' && <WarningIcon size={14} />}
      {percent}
      {level !== 'ok' && <span className="visually-hidden"> ({LEVEL_TEXT[level]})</span>}
    </span>
  );
}
